export function getCommunityRouteSegment(community: { slug?: string | null; id: string }): string {
  return community.slug?.trim() || community.id;
}

export function getBusinessDirectoryPath(community: { slug?: string | null; id: string }): string {
  return `/${getCommunityRouteSegment(community)}/business`;
}

export function getBusinessDirectoryShareUrl(community: {
  slug?: string | null;
  id: string;
}): string {
  if (typeof window === 'undefined') return getBusinessDirectoryPath(community);
  return `${window.location.origin}${getBusinessDirectoryPath(community)}`;
}
